import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const FilterSelect = ({onChange, gadgetType}) => {


  return (
    <div>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label">Filter devices</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={gadgetType}
          onChange={onChange}
          label="Filter devices"
        >
          <MenuItem value="all devices">
            <em>All devices</em>
          </MenuItem>
          <MenuItem value={'iphones'}>Iphone</MenuItem>
          <MenuItem value={'apple watches'}>Apple watches</MenuItem>
          <MenuItem value={'ipads'}>Ipad</MenuItem>
          <MenuItem value={'macbooks'}>Macbooks</MenuItem>
        </Select>
      </FormControl>
      
    </div>
  );
}


export default FilterSelect;